export default "__VITE_ASSET__DfPJbfAb__"